import {FC, Card, PropsWithChildren, useMemo} from 'external/react'

import ButtonBack from 'components/ButtonBack'

import BasicLayout from './BasicLayout'
import useParent from 'context/parent-context/hook'
import Icon from 'external/fortawesome'

const UserPackageContainer: FC<PropsWithChildren> = props => {

    const {children} = props

	const {state: {userPackageDetailsProfile}, params: {role, userId}, navigation} = useParent()
    
    const name = useMemo(() => userPackageDetailsProfile && `${userPackageDetailsProfile.first_name} ${userPackageDetailsProfile.last_name}`, [userPackageDetailsProfile])

    return (
        <BasicLayout>
			<Card.Header style={{ fontSize: '31px' }} className='card--header d-flex'>
                <div className='d-flex flex-column justify-content-center'>
                    <ButtonBack path={navigation.users.link({role})} />
                </div>
                <div className='ms-2' style={{ fontSize: '31px' }}>
                    <Icon name='faBox' />
                    <span className='ml-1'>Detalle de paquetes: {name}</span>
                </div>
            </Card.Header>
            {children}
        </BasicLayout>
    )
}

export {UserPackageContainer as default}